/**
 * Configuration constants for the Mini App
 */

// Debug Mode (Feature Flag)
export const DEBUG_MODE = process.env.REACT_APP_DEBUG_MODE === 'true' || false;

// Smart API Router (Feature Flag)
// Enables automatic failover between primary and replica endpoints
// Can be enabled via: 1) ENV variable, 2) URL parameter (?smart=1)
export const ENABLE_SMART_ROUTER = 
  process.env.REACT_APP_ENABLE_SMART_ROUTER === 'true' ||
  new URLSearchParams(window.location.search).get('smart') === '1';

// Debug helpers (no-op if DEBUG_MODE is false)
export const debugLog = (...args) => {
  if (DEBUG_MODE) {
    console.log('[DEBUG]', ...args);
  }
};

export const debugWarn = (...args) => {
  if (DEBUG_MODE) {
    console.warn('[WARN]', ...args);
  }
};

// Note: console.error() оставляем без условия для критических ошибок

// API Base URL - for Cloudflare Pages we need absolute URL
// Remove trailing slash to prevent double slashes
// Supports both REACT_APP_API_URL (dev) and REACT_APP_API_PRIMARY (prod)
// Fallback to production URL if env vars are not set (safety net for Cloudflare Pages)
export const API_BASE_URL = (
  process.env.REACT_APP_API_URL || 
  process.env.REACT_APP_API_PRIMARY || 
  'https://vpn-admin.shurik.ch'
).replace(/\/$/, '');

// API Replica URL - VDS Mirror (для автоматического failover)
export const API_REPLICA_URL = (process.env.REACT_APP_API_REPLICA || '').replace(/\/$/, '');

// sing-box subscription delivery (Yandex cfg.shurik.ch)
export const SUBSCRIPTION_BASE_URL = (
  process.env.REACT_APP_SUBSCRIPTION_URL || 'https://cfg.shurik.ch'
).replace(/\/$/, '');

/** Build remote profile URL for sing-box / Hiddify. */
export function buildSubscriptionUrl(user) {
  if (!user) {
    return null;
  }
  const token = user.subscription_token;
  if (token && token !== 'None') {
    return `${SUBSCRIPTION_BASE_URL}/${token}`;
  }
  return null;
}

/** Build an HTTPS landing URL that can be opened safely from Telegram WebView. */
export function buildSingBoxLandingUrl(subscriptionUrl) {
  try {
    const url = new URL(subscriptionUrl);
    const lastSlash = url.pathname.lastIndexOf('/');
    const token = url.pathname.slice(lastSlash + 1);
    if (
      url.protocol !== 'https:'
      || url.username
      || url.password
      || url.search
      || url.hash
      || !/^[a-f0-9]{8,32}$/i.test(token)
    ) {
      return null;
    }
    const basePath = url.pathname.slice(0, lastSlash);
    return `${url.origin}${basePath}/import/${token}`;
  } catch (error) {
    return null;
  }
}

// App version (Semantic Versioning)
export const APP_VERSION = process.env.REACT_APP_VERSION || '2.3.0';

// Build number (GitHub Actions run_number)
export const BUILD_NUMBER = process.env.REACT_APP_BUILD_NUMBER || '';

// Full version with build number (if available)
export const FULL_VERSION = BUILD_NUMBER 
  ? `${APP_VERSION}-b${BUILD_NUMBER}`
  : APP_VERSION;

// Helper: Fetch with fallback
export const fetchWithFallback = async (path, options = {}) => {
  const urls = [
    API_BASE_URL ? `${API_BASE_URL}${path}` : path,
    API_REPLICA_URL ? `${API_REPLICA_URL}${path}` : null
  ].filter(Boolean);

  let lastError = null;

  for (const url of urls) {
    try {
      const response = await fetch(url, {
        ...options,
        signal: AbortSignal.timeout(10000) // 10 second timeout
      });
      
      if (response.ok) {
        return response;
      }
      
      lastError = new Error(`HTTP ${response.status}: ${response.statusText}`);
    } catch (error) {
      console.warn(`Failed to fetch from ${url}:`, error.message);
      lastError = error;
    }
  }

  throw lastError || new Error('All API endpoints failed');
};

